// extracted by mini-css-extract-plugin
export default {"overlay":"aA-z","bodyOpen":"bA-z","content":"cA-z","header":"dA-z","close":"eA-z","closeNoHeading":"fA-z"};